import React from 'react';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';

import AppConfigService from 'services/AppConfigService';

const DatePicker = (props) => {
    props = { ...defaultProps, ...props };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker {...props} />
        </MuiPickersUtilsProvider>
    );
}

const defaultProps = {
    fullWidth: true,
    disableToolbar: true,
    variant: 'inline',
    autoOk: true,
    margin: 'normal',
    format: new AppConfigService().getDateFormat()
}

export default DatePicker;
